import { Table } from "@mantine/core";
import { SystemEmailRegistryEntry } from "../../../services/admin/systemEmails.service";
import { SystemEmailRegistryIdentityCells } from "./SystemEmailRegistryIdentityCells";
import { SystemEmailRegistryModeCell } from "./SystemEmailRegistryModeCell";
import { SystemEmailRegistryPreviewCell } from "./SystemEmailRegistryPreviewCell";

interface Props {
  entry: SystemEmailRegistryEntry;
  onPreview: (id: string) => void;
}

export function SystemEmailRegistryRow({ entry, onPreview }: Props) {
  return (
    <Table.Tr>
      <SystemEmailRegistryIdentityCells entry={entry} />
      <SystemEmailRegistryModeCell entry={entry} />
      <SystemEmailRegistryPreviewCell
        entryId={entry.id}
        label={entry.label}
        onPreview={onPreview}
      />
    </Table.Tr>
  );
}
